import {SpinnerService} from "../../modules/SpinnerModule";
import {DebounceFactory} from "../../modules/DebounceModule";
import {DataHubService} from "../../modules/DataHubModule";
import {StateService} from "@uirouter/angularjs";
import {AuthNetHostedProfilePageModeType} from "../../model/AuthNetHostedProfilePageModeType";

export class ReceiveController {
    error: any;
    invoiceGuid = null;
    model = null;
    paymentMethods = [];
    paymentProfiles = [];
    profilesLoading = false;
    modelValidating = false;

    constructor($scope,
                private $timeout,
                private $dataHub: DataHubService,
                private $spinner: SpinnerService,
                private $debounce: DebounceFactory,
                private $state: StateService,
                private $stateParams: any) {
        $dataHub.client.onPaymentMethodUpdated(e => this.paymentMethods.merge(e, x => x.guid));
        $dataHub.client.onPaymentMethodRemoved(e => this.paymentMethods.remove(e, x => x.guid));

        $dataHub.client.onPaymentProfileUpdated(e => this.paymentProfiles.merge(e, x => x.guid));
        $dataHub.client.onPaymentProfileRemoved(e => this.paymentProfiles.remove(e, x => x.guid));


        $dataHub.onConnected(this.refresh);

        $scope.$watch(() => this.model, () => {
            if (!this.modelValidating)
                this.validate();
        }, true);

    }

    refresh = () => {
        var customerGuid = this.$stateParams.customerGuid;
        var invoiceGuid = this.$stateParams.invoiceGuid;

        this.$spinner.show('Loading');
        this.$dataHub.server.paymentMethodSub()
            .then(() => this.$spinner.hide());

        if (customerGuid && !this.model) {
            this.customerSelected({guid: customerGuid});
        }
    };


    handleError = (e) => {
        console.error(e);
        if (e.data && e.data.exceptionMessage) {
            this.error = e.data.exceptionMessage;
        } else {
            this.error = e;
        }
    };

    customerSelected = (customer) => {
        this.$state.go('.', {customerGuid: customer.guid}, {notify: false, reload: false,});
        this.paymentProfiles = [];
        this.$dataHub.server.paymentCreate(customer.guid)
            .then(r => this.model = r);
    };

    refreshPaymentProfiles = () => {
        this.profilesLoading = true;
        this.paymentProfiles = [];
        this.$dataHub.server.paymentProfileSub(this.model.customer.guid)
            .catch(this.handleError)
            .finally(() => this.profilesLoading = false);
    };


    validate = this.$debounce(() => {
        if (!this.model) return;
        if (!this.$dataHub.isConnected) return;
        console.debug('validate', this.model);
        this.modelValidating = true;
        this.$spinner.show('Validating');
        this.$dataHub.server.paymentValidate(this.model)
            .then(r => {
                this.model = r;
                if (this.model.authNetAccount && (!this.paymentProfiles || !this.paymentProfiles.length)) {
                    this.refreshPaymentProfiles();
                }
            })
            .catch(this.handleError)
            .finally(() => {
                this.$spinner.hide();
                this.$timeout(() => {
                        this.modelValidating = false;
                    },
                    100);
            });
    }, 250, false);

    save = () => {
        this.$spinner.show('Processing');
        this.$dataHub.paymentSave(this.model)
            .then(result => {
                this.$state.go("^.view", {paymentGuid: result.guid});
            })
            .catch(this.handleError)
            .finally(this.$spinner.hide);
    }


    addPaymentProfile = () => {
        let mode = AuthNetHostedProfilePageModeType.AddPayment;
        const url = this.$state.href('^.manage', {
            mode: mode,
            customerGuid: this.model.customer.guid,
            gatewayGuid: this.model.authNetAccount.guid
        });
        window.openWindow(url, `profiles${this.model.customer.guid}`, 'Add Payment Card', this.refreshPaymentProfiles);
    };
    managePaymentProfiles = () => {
        let mode = AuthNetHostedProfilePageModeType.Manage;
        const url = this.$state.href('^.manage', {
            mode: mode,
            customerGuid: this.model.customer.guid,
            gatewayGuid: this.model.authNetAccount.guid
        });
        window.openWindow(url, `profiles${this.model.customer.guid}`, 'Manage Payment Profiles', this.refreshPaymentProfiles);
    };


    getCredit = function (credit, invoice) {
        console.log('getCredit', credit, invoice);
        if (!credit || !invoice) return;
        var apply = credit.appliedTo.filter(a => a.txnGuid === invoice.txnGuid)[0];
        return apply ? apply.amount : null;
    };
    setCredit = function (credit, invoice, amount) {
        console.log('setCredit', credit, invoice, amount);
        if (!credit || !invoice) return;
        var apply = credit.appliedTo.filter(a => a.txnGuid === invoice.txnGuid)[0];
        if (!apply) {
            credit.appliedTo.push({
                txnGuid: invoice.txnGuid,
                amount: amount
            });
        } else {
            apply.amount = amount;
        }
    }
    setCreditClick = function (credit, invoice) {
        console.log('setCreditClick', credit, invoice);
        if (!credit || !invoice) return;
        var apply = credit.appliedTo.filter(a => a.txnGuid === invoice.txnGuid)[0];
        if (!apply) {
            credit.appliedTo.push({
                txnGuid: invoice.txnGuid,
                amount: Math.min(invoice.due, credit.balance)
            });
        } else {
            apply.amount = 0;
        }
    }

}

